import { Typography } from "@mui/material";

export { Typography };
